export const initialValues = {
  lowStockField: null,
  storeMessageField: null,
}
